
import { Component, Prop, Vue } from "vue-property-decorator";
import EnglishAssessmentResult, {
  overallInfo
} from "@/lib/model/exam/english/index";

@Component
export default class EnglishProficiency extends Vue {
  @Prop({ default: 1, type: Number }) showType!: number;
  @Prop({
    type: EnglishAssessmentResult,
    default: new EnglishAssessmentResult()
  })
  englishData!: EnglishAssessmentResult;
  @Prop({ type: Boolean, default: false }) isH5!: boolean;
  overallInfo = overallInfo;
  get tableList() {
    return this.englishData.getTable(this.isH5);
  }
}
